<template>
  <div id="app">
    <el-container>
      <el-header>
        <el-main><h2>Пополнение транспортной карты</h2></el-main>
      </el-header>
    </el-container>
    <el-row type="flex" justify="center" id="mainForm">
      <el-col :xs="22" :sm="16" :md="14" :lg="12" :xl="8">
        <el-card shadow="always">
          <el-form :label-position="labelPosition" :model="form" label-width="200px" :rules="rules"
                   @submit.prevent="form" ref="form"
                   status-icon validate-on-rule-change hide-required-asterisk>

            <el-form-item label="slot" prop="cardNumber" :xs="0">
              <span slot="label">Номер карты</span>
              <el-input
                type="text" placeholder="Номер карты" maxlength="19"
                prefix-icon="el-icon-bank-card" v-model.trim="form.cardNumber"></el-input>
            </el-form-item>
            <el-form-item label="slot" prop="topupSum">
              <span slot="label">Сумма пополнения, руб.</span>
              <el-popover
                v-model="isSumPopoverVisible"
                trigger="manual"
                placement="top-start"
                width="380">
                {{ sumTip }}
                <el-input
                  type="number" min="0" placeholder="Сумма пополнения, руб." slot="reference"
                  @focus="isSumPopoverVisible=false"
                  prefix-icon="el-icon-coin" v-model.trim="form.topupSum" @input.native="delayedKeyEvent(700, 'sum')"
                />
              </el-popover>

            </el-form-item>
            <el-form-item label="slot" prop="email">
              <span slot="label">Электронная почта</span>
              <el-input type="text" placeholder="Электронная почта" @focus="isSumPopoverVisible=false"
                        prefix-icon="el-icon-message" v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item>
              <!--              @change="testMethod()"-->
              <el-checkbox v-model="offerCheckBox">Я согласен(-на) с условиями
                <el-link type="primary" @click.prevent="showOffer()">оферты</el-link>
              </el-checkbox>
            </el-form-item>

            <!--            v-if="(testFlag == 0)" class="buttonPay" :disabled=true-->
            <el-form-item>
              <form>
                <el-button type="success" @click="requestPayment()"
                           :disabled="isBtnDisabled">Оплатить
                </el-button>
              </form>
            </el-form-item>


            <!--            v-if="(testFlag == 1)"-->
            <!--            <el-form-item>-->
            <!--              <rbcPayment  v-if="(testFlag == 1)" :key="testFlag"-->
            <!--                              :test="rbcButtonMessage "-->
            <!--              ></rbcPayment>-->
            <!--            </el-form-item>-->

          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios"
//import rbcPayment from "./rbcPayment"

export default {
  name: "App",
  components: {
    //rbcPayment
  },
  data() {
    //debugger;

    let invoice = {
      incvoiceId: '',
      invoiceAccessToken: ''
    };

    let form = {
      cardNumber: '',
      topupSum: '',
      email: ''
    };
    let errors = {};

    let alpikaFlag = false;

    let hostParts = window.location.hostname.split(".");
    let host = hostParts[hostParts.length - 2] || null;

    if(host && host.includes("dnr"))
      alpikaFlag = true;

    var checkIsAlpika  = () => {
       return alpikaFlag;
    };

    var getTxnStatus = () => {

      const transactionId = localStorage.getItem("transaction_id") || sessionStorage.getItem("transaction_id");
      const cardNumber = localStorage.getItem("card_number") || sessionStorage.getItem("card_number");

      var post = {
        transaction_id: transactionId,
        card_number: cardNumber
      };

      axios
        .post(this.API_LOCATION + "/status", post)
        .then(response => {

          if (!response || !response.data || response.data.status === "cancel") {
            window.location.href = "#/error";
            return;
          }

          if (response.data.status === "success") {
            window.location.href = "#/success";
            return;
          }

          var cnt = localStorage.getItem("attempt_cnt") || sessionStorage.getItem("attempt_cnt");

          if (response.data.status === "wait" && cnt < 5) {
            cnt = cnt + 1;
            localStorage.setItem("attempt_cnt", cnt);
            sessionStorage.setItem("attempt_cnt", cnt);

            if (response.data.payment_status === null ||
              response.data.payment_status === "wait") {
              window.setTimeout(getTxnStatus, 1000);
              return;
            }

            if (response.data.payment_status === "success") {
              window.location.href = "#/wait";
              return;
            }

            if (response.data.payment_status === "cancel") {
              //do nothing really
              return;
            }

          } else {
            //do nothing really
          }
        })
        .catch(error => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.error_code
          ) {
            //console.log("Error in txn status get");
          }

          window.location.href = "#/error";
        });
    };

    var initCheckout = (invoiceID, invoiceAccessToken, successPageUrl, email, productName, productDesc) => {

      return RbkmoneyCheckout.configure({
        invoiceID: invoiceID,
        invoiceAccessToken: invoiceAccessToken,
        name: productName,
        description: productDesc,
        email: email,
        paymentFlowHold: true,
        finished: function () {
          window.location.href = "#/await";
        },
        opened: function () {
        },
        closed: function () {
          localStorage.setItem("attempt_cnt", 0);
          sessionStorage.setItem("attempt_cnt", 0);
          getTxnStatus();
        }
      });
    };

    // for SBER
    // var ipay = new IPAY({api_token: 'YRF3C5RFICWISEWFR6GJ'});

    // var showSuccessfulPurchase = function (order) {
    //   console.log(order);
    //alert('Succ ess');
    // };
    //
    // var showFailurefulPurchase = function (order) {
    //   console.log(order);
    //alert('failure');
    // };
    //
    // var initSberCheckout = (amount, order_number, productDesc, email) => {
    //   //debugger;
    //   var curEmail = email;
    //
    //   alert(curEmail);
    //
    //   ipayCheckout({
    //       amount: amount,
    //       currency: 'RUB',
    //       order_number: order_number,
    //       description: productDesc,
    //       jsonParams: {email: curEmail, order_number: order_number}
    //     },
    //     function (order) {
    //       showSuccessfulPurchase(order)
    //     },
    //     function (order) {
    //       showFailurefulPurchase(order)
    //     });
    // };

    //-------------------------------------------------------
    var cardNumberValidator = (rule, value, callback) => {
      var that = this;
      if (value.length !== 19) {
        this.form.topupSum = "";
        return callback(new Error(this.getMessage('0010')));
      } else {

        //if we have errors and card is the same show errors
        if (this.checkedCardNumber === value && !!this.errors && !!this.errors.cardData)
          return callback(new Error(this.errorMessage));

        //if card changed cleat txn and check tariff
        if (this.checkedCardNumber !== value) {
          this.transactionId = "";
          this.isCheckCardTariff = true;

          return cardDataValidator(rule, value, callback);
        }
      }
      return callback();
    };

    var cardDataValidator = (rule, value, callback) => {
      var that = this;

      if (value.length === 19 && !this.isCardDataRequestInProcess) {
        //if we shouldnt check tarif return (current card equal to loaded card tariff)
        if (!this.isCheckCardTariff)
          return callback();

        return this.getTariffData(callback);
      } else {
        return callback();
      }
    };

    var emailValidator = (rule, value, callback) => {
      var context = this;
      this.performDelayedOperation(2000, "emailEnter", function () {
        if (context.form.email.length > 0)
          context.isEmailEntered = true;
      });
      var re = /^(([^<>()[\]\\/,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(value)) {
        this.isEmailEntered = true;
        return callback();
      } else {
        if (this.isEmailEntered) {
          return callback(new Error(this.getMessage('0008')));
        } else {
          return callback();
        }
      }
    };

    var sumValidator = (rule, value, callback) => {
      let res = this.validateTariffAndPrice(value, {includeMax: true});
      if (res.errorCode === 0) {
        return callback()
      } else {
        let errMsg = res.errorMessage ? res.errorMessage : this.getMessage(res.errorCode);
        return callback(new Error(errMsg));
      }
    };

    return {


      APP_ENV: process.env.NODE_ENV,
      API_LOCATION: process.env.API_LOCATION,

      form,
      invoice,
      errors,
      paymentStep: 1,
      testFlag: 0,
      rbcButtonMessage: "Оплатить",
      status: "",
      offerCheckBox: false,
      tariffs: [],


      transactionId: "",
      paymentPageUrl: "",
      selectedTariff: null,
      acquirer: "",

      isCardDataRequestInProcess: false,
      errorCode: 0,
      timers: [0],
      sumTip: "",
      checkedCardNumber: "",
      errorMessage: "",
      isSumPopoverVisible: false,
      isBtnDisabled: true,
      isCheckCardTariff: true,
      labelPosition: window.innerWidth > 550 ? "right" : "top",
      isEmailEntered: false,

      invoiceId: "",
      invoiceAccessToken: "",
      successPageUrl: "",
      productName: "",
      productDescription: "",


      clientMessages: {
        "0001": "Возникла непредвиденная ошибка",
        "0008": "Поле должно содержать валидный адрес электронной почты",
        //"0008": "Адрес содержит недопустимые символы",
        "0009": "Поле обязательно для заполнения",
        "0010": "Поле должно содержать 16 цифр",
        "0012": "Сумма пополнения должна быть кратна #priceStep# руб.",
        "0013": "Значение автоматически скорректировано.",
        "0101": "Пожалуйста, попробуйте ещё раз",
        "0102": "Пожалуйста, попробуйте ещё раз",
        "0103": "Пожалуйста, попробуйте ещё раз",
        "0104": "Вы не можете пополнять указанную карту",
        "0105": "Вы не можете пополнять указанную карту",
        "1001": "Неверный номер карты",
        "1002": "Указанная карта заблокирована",
        "1003": "Онлайн-пополнение для указанной карты недоступно",
        //"1004": "Превышен лимит онлайн-пополнений",
        "1004": "Пополнение будет возможно только после осуществления проезда",
        "1005": "Номер не распознан. Проверьте, что введён номер транспортной карты",
        //"2001": "Не передан номер карты",
        "2001": "Ошибочные параметры",
        "2002": "Не получилось сгенерировать заказ",
        "5001": "Выбран неверный тариф для карты",
        "5002": "Минимальная сумма пополнения на вашем тарифе #priceMin# руб.",
        "5003": "Сумма пополнения превышает максимальную для выбранного тарифа",
        "5003_field": "Максимальная сумма пополнения на вашем тарифе #priceMax# руб.",
        "5004": "Невозможно пополнить на указанную сумму. Сумма должна быть кратна #priceStep# руб.",
        "5011": "Не указан тарифный план (неверный номер карты)",
        "5012": "Некорректный ввод",
        "5013": "Нет согласия с офертой",
        "8001": "Сервис временно недоступен. Ошибка 8001.",
        "8002": "Сервис временно недоступен. Ошибка 8002.",
        "8003": "Сервис временно недоступен. Ошибка 8003.",
        "8004": "Сервис временно недоступен. Ошибка 8004.",
        "9001": "Сервис не смог получить токен от банка.",
        "9002": "Сервис временно недоступен",
      },
      initCheckout: initCheckout,
      //initSberCheckout: initSberCheckout,
      cardNumberValidator: cardNumberValidator,
      cardDataValidator: cardDataValidator,
      emailValidator: emailValidator,
      sumValidator: sumValidator,
      checkIsAlpika: checkIsAlpika
    };
  },
  methods: {
    validatePrice(value) {
      // eslint-disable-next-line no-useless-escape
      var regex = /(^(\+|\-)(0|([1-9][0-9]*))(\.[0-9]{1,2})?$)|(^(0{0,1}|([1-9][0-9]*))(\.[0-9]{1,2})?$)/;
      return (
        regex.test(value) || value === ""
      );
    },
    validateMinPrice(value) {
      return (
        !!this.selectedTariff &&
        value * 100 >= this.selectedTariff.price_min
      );
    },
    validateMaxPrice(value) {
      return (
        !!this.selectedTariff &&
        value * 100 <= this.selectedTariff.price_max
      );
    },
    validateTariffAndPrice(value, options = {}) {
      const includeMax = options.includeMax === true;
      var res = {};
      res.errorCode = 0;
      if (this.selectedTariff === null) {
        //res.errorCode = 5011;
        return res;
      } else if (!this.validatePrice(value)) {
        res.errorCode = 5012;
      } else if (!this.validateMinPrice(value)) {
        res.errorCode = 5002;
        res.errorMessage = this.getMessage('5002', Number(this.selectedTariff.price_min) / 100);
      } else if (includeMax && !this.validateMaxPrice(value)) {
        res.errorCode = 5003;
        res.errorMessage = this.getMessage('5003_field', Number(this.selectedTariff.price_max) / 100);
      }
      return res;
    },
    getMessage(errCode, msgParam) {
      if (this.clientMessages[errCode]) {
        return this.clientMessages[errCode].replace(/(#\w{1,}#)/g, msgParam);
      } else {
        return this.clientMessages["0001"];
      }
    },
    getErrorMessage(errCode) {
      const code = String(errCode);
      let msgParam;
      if (this.selectedTariff) {
        if (code === "5002") {
          msgParam = Number(this.selectedTariff.price_min) / 100;
        } else if (code === "5004" || code === "0012") {
          msgParam = Number(this.selectedTariff.price_step) / 100;
        }
      }
      return this.getMessage(code, msgParam);
    },
    getSBERPaymentWindow() {
      this.initSberCheckout(this.form.topupSum, this.transactionId, this.productDescription, this.form.email);
    },
    getRbcPaymentWindow() {

      if (!this.invoiceId
        || !this.invoiceAccessToken
        || this.invoiceId === ""
        || this.invoiceAccessToken === "") {

        this.errorMessage = this.getMessage('9001');
        this.showErrorMessage();
        return;
      }

      const checkout = this.initCheckout(
        this.invoiceId,
        this.invoiceAccessToken,
        this.successPageUrl,
        this.form.email,
        this.productName,
        this.productDescription
      );

      checkout.open();

      //this.testFlag= (this.testFlag == 1) ? 0 : 1;
      //const checkout = initCheckout('{INVOICE_ID}', '{INVOICE_ACCESS_TOKEN}');
    },
    showErrorMessage() {
      this.$notify({
        title: 'Ошибка',
        message: this.errorMessage
      });
    },
    isPriceSummCorrect() {
      return (
        this.errorCode !== 5012 &&
        this.errorCode !== 5002 &&
        this.errorCode !== 5003
      );
    },
    delayedKeyEvent(ms, id) {
      let context = this;
      if (this.timers[id]) {
        clearTimeout(this.timers[id]);
      }
      this.performDelayedOperation(ms, id, function () {
        context.adductPrice();
      });
    },
    performDelayedOperation(ms, id, callback) {
      if (this.timers[id]) {
        clearTimeout(this.timers[id]);
      }
      this.timers[id] = setTimeout(callback, ms || 0);
    },
    adductPrice() {
      let sum = Number(this.form.topupSum * 100);
      if (this.selectedTariff) {
        let priceStep = Number(this.selectedTariff.price_step);
        let priceMin = Number(this.selectedTariff.price_min);
        if (sum !== 0 && priceStep !== 0 && priceMin <= sum) {
          let stepsNumber = Math.floor(sum / priceStep);
          let sumStepFloor = Number(stepsNumber * priceStep);
          let sumStepCeil = Number((stepsNumber + 1) * priceStep);
          let remainder = sum % priceStep;
          if (remainder !== 0 || this.form.topupSum[0] === '0') {
            if (sum - sumStepFloor < sumStepCeil - sum) {
              this.form.topupSum = Math.floor(sumStepFloor / 100);
            } else {
              this.form.topupSum = Math.floor(sumStepCeil / 100);
            }
            var priceStepRub = priceStep / 100;
            this.sumTip = this.getMessage('0012', priceStepRub) + ' ' + this.getMessage('0013', priceStepRub);
            this.isSumPopoverVisible = true;
            var context = this;
            this.performDelayedOperation(4000, "popover", function () {
              context.isSumPopoverVisible = false;
            });
          }
        }
      }
    },
    showOffer() {
      let offerPath = '../static/offer.html'; // or dynamically set this

      if(this.checkIsAlpika())
        offerPath = '../static/offer_alpika.html';

      const iframeHtml = `<iframe src="${offerPath}" frameborder="0" width="600" height="60" align="left"></iframe>`;


      this.$alert(iframeHtml, 'Оферта:', {
        confirmButtonText: 'Я прочитал(-а)',
        dangerouslyUseHTMLString: true,
        customClass: "messageBoxClass",
        //center:true,
        callback: (action) => {
          if (action === 'confirm')
            this.offerCheckBox = true;
        }
      });

    },
    runValidator(callback) {
      this.clearErrors();
      this.$refs.form.validate(callback);
    },
    clearErrors() {
      this.errors = {};
    },
    getTariffData(callback) {
      var that = this;

      this.clearErrors();
      this.isCardDataRequestInProcess = true;

      var post = {
        card_number: this.form.cardNumber.replace(/\s/g, ""),
        email: this.form.email,
      };

      if (this.form.topupSum !== null && this.form.topupSum !== "")
        post.amount = this.form.topupSum * 100;


      if (this.transactionId !== null && this.transactionId !== "")
        post.transaction_id = this.transaction_id;

      axios.post(this.API_LOCATION + "/start-transaction", post)
        .then(
          response => {
            let error = {};
            if (response.status === 200) {
              if (response.data) {

                this.tariffs = response.data.available_tariffs;
                this.transactionId = response.data.transaction_id;
                this.acquirer = response.data.acquirer;
                localStorage.setItem("transaction_id", response.data.transaction_id);
                localStorage.setItem("card_number", response.data.card_number);

                sessionStorage.setItem("transaction_id", response.data.transaction_id);
                sessionStorage.setItem("card_number", response.data.card_number);
                // Выбираем первый тариф, это должен быть тариф, привязанный к карте
                this.selectedTariff = this.tariffs[0];

                if (this.selectedTariff == null) {
                  error.errorCode = 5011;
                  let errMsg = error.errorMessage ? error.errorMessage : this.getMessage(error.errorCode);
                  this.errors.cardData = errMsg;
                  this.errorMessage = errMsg;

                  return callback(new Error(errMsg));
                }

              }
              this.isCardDataRequestInProcess = false;
              this.checkedCardNumber = this.form.cardNumber;

              this.adductPrice();
              if (this.form.topupSum !== "") {
                this.$refs.form.validateField("topupSum");
              }
              return callback();
            }
          })
        .catch(error => {

          if (error && error.message && !error.response) {
            this.errorMessage = this.getMessage(9002);
            this.showErrorMessage();
            return callback(new Error(this.errorMessage));
          }

          if (
            error.response &&
            error.response.data &&
            error.response.data.error_code
          ) {
            this.errorMessage = this.getErrorMessage(error.response.data.error_code);
            this.errors.cardData = error;
            this.showErrorMessage();
            this.selectedTariff = null;
            this.isCardDataRequestInProcess = false;
            this.checkedCardNumber = this.form.cardNumber;
            this.form.topupSum = "";
            return callback(new Error(this.errorMessage));
          }
        });
    },
    refreshTariffBeforePayment(callback) {
      var post = {
        card_number: this.form.cardNumber.replace(/\s/g, ""),
        email: this.form.email,
      };

      if (this.form.topupSum !== null && this.form.topupSum !== "") {
        post.amount = this.form.topupSum * 100;
      }

      if (this.transactionId !== null && this.transactionId !== "") {
        post.transaction_id = this.transactionId;
      }

      axios.post(this.API_LOCATION + "/start-transaction", post)
        .then(response => {
          if (response.status === 200 && response.data) {
            this.tariffs = response.data.available_tariffs;
            this.transactionId = response.data.transaction_id;
            this.acquirer = response.data.acquirer;
            localStorage.setItem("transaction_id", response.data.transaction_id);
            localStorage.setItem("card_number", response.data.card_number);
            sessionStorage.setItem("transaction_id", response.data.transaction_id);
            sessionStorage.setItem("card_number", response.data.card_number);
            this.selectedTariff = this.tariffs[0];

            if (this.selectedTariff == null) {
              this.errorMessage = this.getMessage(5011);
              this.showErrorMessage();
              return callback(new Error(this.errorMessage));
            }

            return callback();
          }
          this.errorMessage = this.getMessage(9002);
          this.showErrorMessage();
          return callback(new Error(this.errorMessage));
        })
        .catch(error => {
          if (error && error.message && !error.response) {
            this.errorMessage = this.getMessage(9002);
            this.showErrorMessage();
            return callback(new Error(this.errorMessage));
          }

          if (
            error.response &&
            error.response.data &&
            error.response.data.error_code
          ) {
            const code = String(error.response.data.error_code);
            this.errorMessage = code === "5003"
              ? this.getMessage("5003")
              : this.getErrorMessage(code);
            this.showErrorMessage();
            if (code === "5003") {
              this.isBtnDisabled = true;
            }
            return callback(new Error(this.errorMessage));
          }

          this.errorMessage = this.getMessage(9002);
          this.showErrorMessage();
          return callback(new Error(this.errorMessage));
        });
    },
    proceedPayment() {
      let returnTest = 'https://topup-test.kpbs.ru/#/await';
      let failTest = 'https://topup-test.kpbs.ru/#/error';
      let returnProd = 'https://online.elbius.ru/#/await';
      let failProd = 'https://online.elbius.ru/#/error';

      if(this.checkIsAlpika())
        returnProd = 'https://payment.tkdnr.ru/#/await';
        failProd = 'https://payment.tkdnr.ru/#/error';

      let failUrl;
      let successUrl;
      if (this.APP_ENV === "development") {
        failUrl = failTest;
        successUrl = returnTest;
      } else {
        failUrl = failProd;
        successUrl = returnProd;
      }

      var post = {
        comment: "Elbius Online Topup",
        email: this.form.email,
        tariff_id: this.selectedTariff.tariff_id,
        amount: this.form.topupSum * 100,
        transaction_id: this.transactionId,
        card_number: localStorage.getItem("card_number") || sessionStorage.getItem("card_number"),
        return_url: successUrl,
        fail_url: failUrl
      }

      if (this.acquirer === "rbk") {
        axios
          .post(this.API_LOCATION + "/requestPaymentToken", post)
          .then(response => {

            if (response.status === 200) {

              this.invoiceId = response.data.invoice_id
              this.invoiceAccessToken = response.data.token
              this.successPageUrl = response.data.success_page

              this.productName = response.data.product_name
              this.productDescription = response.data.product_description

              //window.location.href = response.data.page_url;
              this.getRbcPaymentWindow();
            }

          })
          .catch(error => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.error_code
            ) {

              this.errorMessage = this.getErrorMessage(error.response.data.error_code);
              this.errors.cardData = error;
              this.showErrorMessage();
            }
          });
      } else {
        axios
          .post(this.API_LOCATION + "/payment", post)
          .then(response => {
            if (response.status === 200) {
              if (response.data.page_url) {
                window.location.href = response.data.page_url;
              }
            }
          })
          .catch(error => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.error_code
            ) {
              this.errorMessage = this.getErrorMessage(error.response.data.error_code);
              this.showErrorMessage();
            }
          });
      }
    },
    requestPayment() {
      this.runValidator(valid => {
        if (!valid) {
          this.errorMessage = this.getErrorMessage(this.errorCode);
          return;
        }

        this.refreshTariffBeforePayment(err => {
          if (err) {
            return;
          }

          const maxPriceValidation = this.validateTariffAndPrice(this.form.topupSum, {includeMax: true});
          if (maxPriceValidation.errorCode === 5003) {
            this.errorMessage = this.getMessage('5003');
            this.showErrorMessage();
            this.$refs.form.validateField("topupSum");
            this.isBtnDisabled = true;
            return;
          }

          this.proceedPayment();
        });
      });
    },
  },
  computed: {
    rules() {
      return {
        cardNumber: [
          {validator: this.cardNumberValidator, trigger: 'blur'},
          {validator: this.cardDataValidator, trigger: 'change'}
        ],
        email: [
          {required: true, message: this.clientMessages['0009'], trigger: 'blur'},
          {validator: this.emailValidator, trigger: 'change'}
        ],
        topupSum: [
          {required: true, message: this.clientMessages['0009'], trigger: 'blur'},
          {validator: this.sumValidator, trigger: 'change'},
          {validator: this.sumValidator, trigger: 'blur'}
        ]
      }
    }
  },
  created() {
    this.$multiwatch(['form.cardNumber', 'form.topupSum', 'form.email', 'offerCheckBox'], function () {
      if (this.form.cardNumber === "") {
        return false;
      }

      //drop space and drop non digit
      //let arr = this.form.cardNumber.replace(/\s+/g,"").replace(/[^0-9]/g, "");
      let arr = this.form.cardNumber.replace(/[^0-9]/g, "");

      if (arr !== "" && arr.length % 4 == 0) {
        arr = arr
          .match(/.{1,4}/g)
          .join(" ")
          .slice(0, 19);
        this.form.cardNumber = arr;
      } else {
        //this.form.cardNumber = arr;
        return false;
      }

      var formFields = Object.keys(this.form),
        passed = true;
      for (var i = 0; i < formFields.length; i++) {
        passed = passed && (this.form[formFields[i]].length !== 0) && this.isEmailEntered;
      }
      if (passed && Object.keys(this.errors).length === 0) {
        this.runValidator(valid => {
          this.isBtnDisabled = !valid || !this.offerCheckBox;
        });
      } else if (this.checkedCardNumber === this.form.cardNumber) {
        this.isCheckCardTariff = false;
      }
    })
  },
  mounted() {
    window.onresize = () => {
      this.labelPosition = window.innerWidth > 550 ? "right" : "top";
    };

    //this.drawRbcButtonOnForm();
  }
};
</script>
<style>
.buttonPay {
  display: inline-block;
  position: relative;
  overflow: hidden;
  visibility: visible;
  padding: 8px 12px;
  outline: 0;
  font: bold 14px/14px 'Helvetica Neue', Helvetica, Arial, sans-serif;
  text-decoration: none;
  color: #fff;
  border: 1px solid #2384c1;
  border-radius: 5px;
  background-image: linear-gradient(#7dc5ee, #008cdd 85%, #30a2e4);
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
}

.messageBoxClass {
  /*background-color: #5daf34;*/
  width: 60vw !important;
}

iframe {
  display: block; /* iframes are inline by default */
  /*background: #000;*/
  border: none; /* Reset default border */
  height: 70vh; /* Viewport-relative units */
  width: 55vw;
}

#mainForm .el-form-item__error {
  position: static;
  padding-top: 6px;
  line-height: 1.35;
  white-space: normal;
  word-break: break-word;
}

/* Higher specificity than Element UI's .el-notification__content { text-align: justify }
   so the rule survives production CSS extract/order (dev injects later and "wins" by accident). */
.el-notification .el-notification__content {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/payment.vue